import React, { FC, useState } from 'react'
import { Trans, t } from '@lingui/macro'
import IconFont from '../../../../../components/common/IconFont'
import { ButtonDark } from 'front-end/src/components'
import IconFilter from 'public/assets/img/filter-icon.svg'
import './DashboardsFilter.less'
import { DateRangeFilterModal } from '../../../../../components/common/date-range-filter-modal/DateRangeFilterModal'
import { useDateFilterContext } from '../../../../../components/common/dateFilter'
import { showSelectedRangeOrCustom } from 'front-end/src/components/utils/predefinedDateRanges'

export interface IDashboardsFilters {
  from: Date
  to: Date
}

export enum DashboardsFiltersEnum {
  DATE_FILTER = 'DATE_FILTER'
}

interface IProps {
  activeFilters?: Array<DashboardsFiltersEnum>
}

enum ModalFiltersEnum {
  DATE = 'DATE'
}

const DashboardsFilter: FC<IProps> = ({
  activeFilters = [DashboardsFiltersEnum.DATE_FILTER]
}) => {
  const [filters, setFilters] = useDateFilterContext()
  const [activeModalFilter, setActiveModalFilter] =
    useState<ModalFiltersEnum | null>(null)

  return (
    <div className="DashboardsFilter">
      <div className="DashboardsFilter__wrapper">
        <label className="DashboardsFilter__label">
          <img
            className="DashboardsFilter__label__icon"
            src={IconFilter}
            alt={t`Filter`}
          />
          <Trans>Showing</Trans>:
        </label>
        <ButtonDark
          className="DashboardsFilter__item"
          onClick={() => setActiveModalFilter(ModalFiltersEnum.DATE)}
        >
          <span className="DashboardsFilter__item__label">
            <Trans>Date</Trans>: {showSelectedRangeOrCustom(filters)}
          </span>
          <span className="DashboardsFilter__item__icon">
            <IconFont type="pencil" />
          </span>
        </ButtonDark>
      </div>

      {activeFilters?.includes(DashboardsFiltersEnum.DATE_FILTER) && (
        <DateRangeFilterModal
          isOpened={activeModalFilter === ModalFiltersEnum.DATE}
          closeModal={() => setActiveModalFilter(null)}
          onFilterSubmit={setFilters}
          {...filters}
        />
      )}
    </div>
  )
}

export default DashboardsFilter
